import { defineMessage } from '@lingui/core/macro';
import { UnitJsonConfig } from '@/core/types/battle.types';

export const bek: UnitJsonConfig = {
    id: 'bek',
    unitName: defineMessage({ message: 'Bek' }),
    stats: {
        hp: 100,
        stamina: 120,
        speed: 3,
        initiative: 28,
        armor: 50,
        evasion: 5,
        meleeSkill: 95,
        armorPenetration: 0.5,
        damageMin: 9,
        damageMax: 13,
        critChance: 10,
        critMult: 1.2,
    },
    skills: [
        {
        id: 'c_t_mace',
        name: defineMessage({ message: 'Mace Strike' }),
        sort: 10,
        cost: 45,
        range: 1,
        powerMult: 1.0,
        critChanceBonus: 5,
        hitChanceBonus: 5,
        iconRow: 1,
        iconCol: 0,
    },
    ],
    anchor: {
        x: 0.5,
        y: 0.75,
    },
    badge: {
        x: 70,
        y: -220,
    },
    unitPortrait: {
        row: 1,
        col: 0,
    },
} satisfies UnitJsonConfig;
